import React, { ReactElement } from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getLayout } from 'components/layouts/Header';

import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import ManagerWrapper from './Manager.component';

const Manager = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Manage | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <ManagerWrapper />
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

const ManagerMain = withAuthCandidate(Manager);

// @ts-ignore
ManagerMain.getLayout = getLayout;

export default ManagerMain;
